import api from './client';
export type ApplicationParameter = {
  name: string;
  description: string;
  data_type: 'number' | 'boolean' | 'text';
  value: string | number | boolean;
  fixed_type: boolean;
  updated_on: string;
};
export async function fetchApplicationParameters() {
  return (await api.get<ApplicationParameter[]>('/application-parameters')).data;
}
export async function saveApplicationParameter(parameter: ApplicationParameter) {
  return (await api.put<ApplicationParameter>(`/application-parameters/${encodeURIComponent(parameter.name)}`, {
    description: parameter.description, data_type: parameter.data_type, value: parameter.value,
  })).data;
}
